<template>
  <div class="w-64">
    <MultiSelect
      :value="selectedValue"
      :options="groups"
      :searchable="true"
      :can-clear="false"
      :can-deselect="false"
      placeholder="Alle Groepen"
      no-options-text="Geen groepen beschikbaar"
      no-results-text="Geen groep gevonden"
      @input="onChange"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import MultiSelect from '@/components/shared/MultiSelect.vue'

export default {
  name: 'DropDownGroup',
  components: { MultiSelect },
  computed: {
    ...mapState(['user', 'selectedGroup', 'availableGroups']),
    groups() {
      return ['Alle Groepen', ...this.availableGroups.map((group) => group.name)]
    },
    // A native <select> falls back to its first option when the bound value is
    // not in the list; mirror that so the select never renders blank.
    selectedValue() {
      return this.groups.includes(this.selectedGroup) ? this.selectedGroup : this.groups[0]
    },
  },
  methods: {
    ...mapMutations(['setSelectedGroup']),
    onChange(value) {
      this.setSelectedGroup(value)
    },
  },
}
</script>
